type ViewDataButtonProps = {
  onClick: () => void;
  loading?: boolean;
};

export function ViewDataButton({
  onClick,
  loading = false,
}: ViewDataButtonProps) {
  return (
    <button
      data-testid="viewData"
      onClick={onClick}
      className="fixed z-40 bottom-4 right-4 sm:right-6 sm:bottom-6 inline-flex items-center justify-center gap-2 bg-primary hover:bg-primary-deep text-white px-5 py-3 sm:px-6 rounded-xl font-semibold shadow-lg transition-colors"
    >
      {loading ? (
        'Loading…'
      ) : (
        <>
          See my data
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M14 5l7 7m0 0l-7 7m7-7H3"
            />
          </svg>
        </>
      )}
    </button>
  );
}
